<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: 王佳兴
 * @LastEditTime: 2019-01-03 15:08:47
 -->
<template>
  <div id="detailTop" :class="[playClass ? 'has_play_img' : '']">
    <div class="register_div" v-if="!canPlay">
      <p>请登录后继续观看视频！</p>
      <div @click="toRegister">登录</div>
    </div>
    <video
      v-else-if="canPlay"
      ref="video"
      id="ele_video"
      :poster="pic"
      controls="true"
      :src="courseVideUrl"
      playsinline="true"
      webkit-playsinline="true"
      x-webkit-airplay="true"
      x5-playsinline
    ></video>
    <img :src="pic" v-if="!canPlay" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { courseReport } from '@/api/ajax.js';

import { contentview } from '@/Mixin/contentview.js';
export default {
  name: '',
  mixins: [contentview],
  props: {
    pic: {
      default: 'http://yxvzb.b0.upaiyun.com//images/1510561442518.png'
    },
    categoriesArr: {
      type: Array,
      default() {
        return [];
      }
    },
    detailObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      show: false,
      controls: false,
      playClass: false,

      canPlay: true
    };
  },
  computed: {
    ...mapState({
      courseVideUrl: state => state.courseVideUrl
    })
  },
  watch: {
    detailObj(val) {
      let fn = () => {
        if (this.$route.query.limit != 'noLimit') {
          setTimeout(() => {
            // 新用户试看三分钟
            this.$refs.video.pause();
            this.canPlay = false;
            document.webkitCancelFullScreen();
            this.$vux.toast.show({
              type: 'text',
              text: '未注册用户只能试看3分钟',
              position: 'top',
              width: '8rem'
            });
          }, 3 * 60 * 1000);
        }
      };
      this.$nextTick(() => {
        this.pageStayTime('录播');
        this.videoPlay('录播', fn);
      });
    }
  },
  methods: {
    toRegister() {
      this.$router.push({ name: 'register' });
    }
  },
  mounted() {
    this.scType = this.$route.query.shequn ? 'shequn' : 'share';
    // let $vm = this
    // setTimeout(() => {
    //   try {
    //     this.$refs.video.addEventListener('play', function() {
    //       if ($vm.interCourseTime == null) { // 1分钟定时上报观看
    //         $vm.interCourseTime = setInterval(() => {
    //           courseReport({
    //             courseId: $vm.$route.params.id
    //           }).then(res => {
    //           });
    //           let wxUserInfoObj = $vm.$api.getStorage('wxUserInfo')
    //           //定时观看上报SC
    //           sa.track('course_report', {
    //             pageUrl: location.href,
    //             course_id: $vm.$route.params.id,
    //             course_name: $vm.detailObj.courseName,
    //             client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
    //             course_type: 'video',
    //             from: 'wx',
    //             chapter_name: $vm.detailObj.courseName
    //           });
    //         }, 60 * 1000)
    //       }
    //     });
    //   } catch (e) {
    //     console.error('没有章节')
    //   }
    // }, 1000)

    // this.$refs.video.addEventListener('click',function(){

    //   requestFullScreen();
    // //5秒钟自动退出全屏
    //   setTimeout(function(){
    //     exitFullscreen();
    //   },5000);
    // },false);
  }
};
</script>

<style scoped lang="less">
#detailTop {
  width: 100%;
  height: 5.6266rem;
  position: relative;
  * {
    max-width: 100%;
    height: 5.6266rem;
  }
  #ele_video {
    width: 100%;
    height: 5.6266rem;
  }
  .register_div {
    width: 5.65rem;
    height: 3.33rem;
    border-radius: 0.13rem;
    background: rgba(255, 255, 255, 0.95);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding-top: 0.85rem;
    padding-bottom: 0.59rem;
    p {
      font-size: 0.43rem;
      color: #333333;
      text-align: center;
      margin-bottom: 0.49rem;
      height: 0.6428rem;
    }
    div {
      width: 2.67rem;
      height: 0.8rem;
      background: #027cfa;
      border-radius: 0.11rem;
      text-align: center;
      line-height: 0.8rem;
      font-size: 0.4rem;
      color: #ffffff;
      margin: auto;
    }
  }
}
.has_play_img:before {
  content: '';
  background: url('//cdn.yxvzb.com/img/playimg.png') no-repeat;
  background-size: 100%;
  width: 2rem;
  height: 2rem;
  position: absolute;
  top: 1.5rem;
  left: 50%;
  z-index: 2;
  margin-left: -1rem;
}
</style>
